import { useMutation } from '@tanstack/react-query';
import api from '@/services/api';

export type PlanogramCatalogRow = {
    id: number;
    product_id: number;
    planogram_code: string;
    bar_code: string;
    product_name: string;
    status: string;
    standard_amount: number;
    alert_level: number;
    price_list_in_cents: number;
    price_final_in_cents: number;
    stock_amount: number;
    due_date?: string | null;
};

export type SavePlanogramCatalogParams = {
    storeId: number;
    dataUpdate?: PlanogramCatalogRow[];
    dataDelete?: number[];
};

const savePlanogramCatalog = async ({
    storeId,
    dataUpdate = [],
    dataDelete = [],
}: SavePlanogramCatalogParams) => {
    const response = await api.post(`/store/${storeId}/planogram`, {
        dataCreate: [],
        dataUpdate,
        dataDelete,
    });
    return response.data;
};

export const useSavePlanogramCatalog = () =>
    useMutation({ mutationFn: savePlanogramCatalog });
